import { HANDLE_COMPANY_DETAIL, RESET } from '../actions';

const initialState = {
    company: {},
    user: [],
    device: [],    
    deviceSearch: "",
    userSearch: "",

    userModal: false,
    deviceModal: false
};

const CompanyDetail = (state = initialState, action) => {
    
    switch (action.type) {
        case HANDLE_COMPANY_DETAIL:
            return {
                ...state,
                ...action.data
            };
        case RESET:
            return initialState;
        default:
            return state;
    }
};

export default CompanyDetail;